import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { LOCALSTORAGE } from "./constants";
import { parse, isValid, format } from "date-fns"
import { getData } from "./storage";


const parseDateString = (str: string): Date | null => {
  const formats = [
    "dd-MM-yyyy HH:mm",
    "dd-MM-yyyy",
    "MM-dd-yyyy HH:mm",
    "MM-dd-yyyy",
    "dd-MMM-yyyy HH:mm",
    "dd-MMM-yyyy",
  ];

  for (const format of formats) {
    const parsedDate = parse(str, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }

  return null;
};
export const getFormattedDate = (
  date: Date | string | number | null | undefined,
  dateFormat: string
): string | null => {
   if (!date) return null;
  const properFormat = dateFormat.replaceAll('D', 'd').replaceAll('Y', 'y');
  return format(new Date(date), properFormat);
  // return formateDate(date as string, dateFormat)
};

export const ExportCSV = async (
  csvData: any[],
  fileName: string,
  roleName: string
) => {

  // 🔹 Convert date-like strings to JS Date
  const convertedData = csvData.map((row) => {
    const newRow: any = {};

    Object.keys(row).forEach((key) => {
      const value = row[key];

      if (typeof value === "string") {
        const parsed = parseDateString(value);
        newRow[key] = parsed ? parsed : value;
      } else {
        newRow[key] = value;
      }
    });

    return newRow;
  });

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(roleName);

  if (convertedData.length === 0) return;

  // 🔹 Add headers
  const headers = Object.keys(convertedData[0]);
  worksheet.addRow(headers);

  // 🔹 Add rows
  convertedData.forEach((row) => {
    worksheet.addRow(headers.map((h) => row[h]));
  });

  // 🔹 Format Date columns
  worksheet.columns.forEach((column) => {
    column?.eachCell?.((cell) => {
      if (cell.value instanceof Date) {
        cell.numFmt = "dd-mm-yyyy";
      }
    });
  });

  // 🔹 Auto column width
  worksheet.columns.forEach((column) => {
    column.width = 20;
  });

  // 🔹 Generate file buffer
  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob(
    [buffer],
    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
  );

  saveAs(blob, `${fileName}.xlsx`);
};

export const helperExportCSV = async (csvData: any[], fileName: string) => {

  const facilityData :[]= getData(LOCALSTORAGE.FACILITY, false)!;

  const facilityDetails: any =
    facilityData?.length !== 0
      ? getData(LOCALSTORAGE.FACILITYID, false)!
      : "";

  // 🔹 Detect date-like strings and convert to JS Date
  const convertedData = csvData.map((row) => {
    const newRow: any = {};

    Object.keys(row).forEach((key) => {
      const value = row[key];

      if (typeof value === "string") {
        const parsed = parseDateString(value);
        newRow[key] = parsed ? parsed : value;
      } else {
        newRow[key] = value;
      }
    });

    return newRow;
  });

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("data");

  if (convertedData.length === 0) return;

  // 🔹 Add headers
  const headers = Object.keys(convertedData[0]);
  worksheet.addRow(headers);

  // 🔹 Add rows
  convertedData.forEach((row) => {
    worksheet.addRow(headers.map((h) => row[h]));
  });

  // 🔹 Apply date format
  worksheet.columns.forEach((column) => {
    column?.eachCell?.((cell) => {
      if (cell.value instanceof Date) {
        cell.numFmt = "dd-mm-yyyy";
      }
    });
  });

  // 🔹 Auto column width
  worksheet.columns.forEach((column) => {
    column.width = 20;
  });

  // 🔹 Generate Excel buffer
  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob(
    [buffer],
    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
  );

  saveAs(blob, `${fileName}.xlsx`);
};



export const handleDownloadExcel = async (data: any[], fileName: string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  if (data.length === 0) return;

  // Add headers
  const headers = Object.keys(data[0]);
  worksheet.addRow(headers);

  // Add rows
  data.forEach((item) => {
    worksheet.addRow(headers.map((key) => item[key]));
  });

  // Generate Excel buffer
  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${fileName}.xlsx`);
};


export const base64ToFile = async (base64: any) => {
  const res = await fetch(base64);
  const buf = await res.arrayBuffer();
  var blob = new Blob([buf], { type: "image/bmp" });

  return blob;
};

export const formatFileSize = (bytes: number): string => {
  if (!bytes || bytes === 0) return '0 KB';

  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${kb.toFixed(1)} KB`;
  }

  return `${(kb / 1024).toFixed(1)} MB`;
};
export const getFileSize = async (fileURL: any) => {
  try {
    const response = await fetch(fileURL);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    return formatFileSize(blob.size);

  } catch (error: any) {

    return 'Unknown';
  }
};
